export default {
  common: {
    campany: 'COMPANY',
    ourStory: 'ARTIST',
    audition: 'AUDITION',
    contact: 'CONTACT',
    information: 'INFORMATION',
    blix: 'BLIX CREATES THE FUTURE OF ENTERTAINMENT —',
    makingTomorrow: 'MAKING TOMORROW’S',
    inspirations: 'INSPIRATIONS POSSIBLE TODAY',
    home: 'HOME',
    copyrightBlix: '© Copyright Blix Entertainment. ALL RIGHT RESERVED',
    standsFor: '"BLIX" STANDS FOR',
    brilltance: 'BRILLIANCE.',
    speed: 'SPEED.',
    stability: 'STABILITY.',
    vitality: 'VITALITY.',
    tip: 'BLIXは、アーティストの発掘・育成、音楽制作、技術革新を基盤とし、音楽制作と技術革新を融合させることで、世界市場において競争力のあるコンテンツと創造的なストーリーテリングを包括する統合的なエコシステムを構築する、未来志向のクリエイティブ・エンターテインメント企業です。私たちはグローバルな舞台で、韓国エンターテインメントの新しい基準を築く企業となるでしょう。',
    tip1: '私たちは、創造性こそが持続的な力であり、その力によってBLIXが世界を動かすと信じています。創造性は絶えず燃え上がり、止まらないエネルギーで世界に新たなインスピレーションを与えます。',
    tip2: 'BLIXは体系的なエンターテインメントシステムで運営され、ストーリーとアーティスト、そして世界中のファンをひとつにつなぎ、最高のエンターテインメントを提供します。',
    tip3: 'BLIXは創造性と専門性を融合させた体系的なシステムにより、アーティストの成長プロセス全体を支援します。専門的なトレーニングから音楽制作・ビジュアルストーリーテリング・ブランディング、さらにはグローバルステージまでをつなぐ堅固なシステムを通して、持続可能で長期的な影響力を築きます',
    visionary: 'VISIONARY ENTERTAINMENT',
    tip4: '急速に変化するグローバル市場および創造経済の中で、BLIXは持続可能で柔軟なエンターテインメントシステムを構築してきました。すべてのプロセスは専門的な基準と育成、そして未来志向のビジョンに基づき精緻に設計され、新しいエンターテインメントの方向性を提示します。',
    atTheHeart:'BLIXの中心には、無限の可能性と新たなビジョンがあります。', 
    wePrepare:'私たちはトレンドを超え、世代をリードする文化の舞台を準備します。', 
    togetherWeGrow:'共に成長し、世界において新たな基準となるBLIXエンターテインメントを目指します。',
    ourCompleteSystem: 'OUR COMPLETE SYSTEM',
    casting: 'CASTING',
    trainingDevelopment: 'TRAINING & DEVELOPMENT',
    musicProduction: 'MUSIC PRODUCTION',
    brandingStoryIP: 'BRANDING & STORY IP',
    marketingFanSystem: 'MARKETING & FAN SYSTEM',
    globalBusiness: 'GLOBAL BUSINESS',
    crossIndustryCollaboration: 'CROSS-INDUSTRY COLLABORATION',
    weContinue: 'BLIXは文化のイノベーターと共に成長し、以下の分野と協力しています。',
    artists: 'ARTISTS',
    technologyDevelopers: 'TECHNOLOGTY',
    creativeStrategists: 'CREATIVE STRATEGISTS',
    weBelieve: 'BLIXは文化のイノベーターと共に成長し、アーティストの育成や活動を支援するとともに、以下の分野と協力しています。',
    atBlix:'アーティストの夢こそが私たちの未来であるとBLIXは信じています。',
    thatFunture:'その未来はすでにここで、音楽と物語を通して現実となり始めています。',
    creativeSpace: 'CREATIVE SPACE',
    tip5: 'あなたは BLIX のグローバルアーティスト企画に加わり、専属の成長の旅路に踏み出し、世界の注目へと歩み始めます',
    spotlight: 'Join BLIX — 世界へ羽ばたくアーティストの旅は、ここから始まります。',
    blixShien: 'BLIXは次世代アーティストが専門的なトレーニングを通じて成長し、輝ける最適な環境を提供します',
    tip20: '音楽・ビジュアル、そして力強いストーリーテリングを通じて、新しい時代の革新的なパフォーマンスを創り出します。アーティストを夢見るすべての人がステージの中心に立ち、自分だけの物語を輝かせられるよう、惜しみなく育成します。',
    forYou: '世界の舞台へ踏み出す第一歩、BLIXはあなたを待っています',
    apllyNow: 'APLLY NOW',
    pleaseleave:'ご質問を送信いただければ、当チームが確認後ご返信いたします。',
    name:'氏名',
    email:'メール',
    contactNumber:'連絡先',
    inquiryDetails:'お問い合わせ内容',
    agreePolicy:'個人情報取扱方針に同意します',
    contact2:"CONTACT",
    submitInquiry:'送信',
    seoulHq:'SEOUL HQ ',
    add:'6 SEONGMISAN-RO 6-GIL, ',
    add1:'MAPO-GU, SEOUL, ',
    add2:'REPUBLIC OF KOREA [03996]',
    add3:'서울특별시 마포구 성미산로6길 6 (망원동, BLIX 빌딩) ',
    hongKong:'HONG KONG OFFFICE',
    midtown:'1811, ONE MIDTOWN,',
    hoiShing:'11 HOI SHING ROAD, TSUEN WAN,',
    hongKong1:' HONG KONG',
    onlineAuditin:'オンライン試聴ガイド',
    auditionCategories:'オーディションカテゴリー',
    dataTyle:'声楽/ラップ/ダンス/パフォーマンス',
    applicationPeriod:'応募期間',
    openYearRound:'通年受付', 
    eligibility:'応募資格', 
    noRestrictions:'制限なし — 誰でも応募可能', 
    howToApply:'申請方法',
    step1:'ステップ 1',
    auditionForm:'「応募する」をクリックして、オーディション申込書を記入してください。',
    step2:'ステップ 2',
    uploadRequired:'必須提出ファイル',
    photos:'写真',
    clearPhoto:'半身正面写真 1枚',
    frontView:'全身正面写真 1枚',
    videoSubmission:'動画',
    videoAudio:'ボーカル／ラップ：1分以上の歌唱またはラップ（動画または音声ファイル）',
    freestyledancing:'ダンス：1分以上のフリースタイルダンス動画',
    actingPerformance:'演技：1分以上のモノローグまたは演技動画e',
    step3:'ステップ 3',
    submityour:'応募書類を提出して手続きを完了してください。',
    auditionProcess:'オーディションプロセス',
    stRound:'一次審査：書類選考',
    videoSubmissionReview:'応募書類・写真・動画を審査します。',
    ndRound:'二次審査：カメラテスト',
    recordedVideoTest:'選ばれた応募者は録画テストに参加します。',
    rdRound:'最終審査：現場オーディション & 結果通知',
    afterThisRound:'最終候補者は現場オーディションに招待され、この段階で最終結果が決定されます',
    auditionResults:'オーディション結果',
    tip6:'合格者は、応募書に記載されたメールまたは電話にて、オーディション日から2週間以内に個別に通知されます。.',
    auditionResultsNotification:'オーディション結果通知',
    tip7:'合格者のみ、応募書類に記載されたメールアドレスまたは電話番号へご連絡いたします。結果はオーディション日から2週間以内に通知されます。',
    importantNotes:'注意事項',
    beReturned:'提出された資料は返却されません',
    anyPhotosThat:'過度に修正・加工された写真（例：Photoshop使用）は審査で失格となる可能性があります。',
    videosAudio:'低画質の動画・音声（例：ぼやけ、ピント不良、音質不良）は審査に不利になる可能性があります。',
    questionsFurther:'お問い合わせや追加サポートが必要な場合は以下までご連絡ください：',
    apply:'APPLY',
    pleaseEnter1:'オーディション応募のために正確な情報を入力してください。',
    emailAddress:'メールアドレス',
    VerifyEmail:'メール確認',
    lastName:'みょうじ',
    firstName:'なまえ',
    dateOfBirth:'生年月日',
    select:'選択してください',
    enter:'入力してください',
    profilePicture:'データ画像',
    upload:'アップロード',
    pleaseUpload:'アップロードしてください',
    performanceCategory:'パフォーマンスカテゴリー',
    gender:'性別',
    height:'身長',
    height1:'身長(CM)',
    weight:'体重',
    weight1:'体重(KG)',
    phone:'電話番号',
    phone1:'フォームに記入してください',
    schoolJob:'学校/職業',
    schoolJob1:'フォームに記入してください',
    emergencyContact:'緊急連絡先',
    emergencyContact1:'フォームに記入してください',
    placeOfresidence:'居住地',
    socialMediaId:'SNS ID',
    specialtv:'特技',
    activtiesAwarsds:'活動・受賞歴',
    activtiesExperience:'オーディション経験',
    specialNote:'特記事項',
    attachFile:'ATTACH FILE',
    profileAttachFile:'プロフィール添付ファイル',
    consentInformation:'個人情報取扱方針に同意します',
    submitApplicatior:'応募を送信',
    tit1:'個人情報取扱方針に同意します',
    tip8:'応募者は、BLIXエンターテインメント（以下「当社」）が下記の目的で個人情報を収集・利用することに同意します。',
    tip9:"収集目的と項目: 本人確認、オーディション応募管理、才能の適性評価、練習生選抜手続き。収集項目：氏名、生年月日、国籍、住所、メール、連絡先、年齢、身長、体重、受賞歴・学歴、学校・学年、SNSアカウント、写真・動画。",
    tip10:"本人確認、オーディション応募管理、才能の適性評価、練習生選抜手続き。収集項目：氏名、生年月日、国籍、住所、メール、連絡先、年齢、身長、体重、受賞歴・学歴、学校・学年、SNSアカウント、写真・動画。",
    tip11:"保有・利用期間：同意日から2年間、または書面撤回まで有効。応募者は情報変更を速やかに通知する義務があります。",
    tip12:"応募者は、提供した情報に変更がある場合、速やかに当社に通知する義務があります。当社は同一の条件で更新された情報を収集・利用する権利を有します。",
    tip13:"同意を拒否した場合、応募を処理できない、またはオーディション関連の手続きが進まない可能性があります。これにより生じる不利益はすべて応募者の自己責任となります。",
    tit2:'[個人情報の第三者委託]',
    tip14:'委託目的：サーバーを通じてBLIXエンターテインメントのオーディションプラットフォーム及び関連データを安全に運営・管理するため。',
    tip15:"応募者は、第三者によるデータ処理への同意を拒否する権利を有します。ただし、拒否した場合、公式プラットフォームでのオーディション参加が制限される可能性があります。",
    tit3:'[コンテンツ記録・利用同意]',
    tip16:'応募者は、オーディション中に当社が本人の映像・声・写真・パフォーマンスを記録・撮影・利用することに同意します。すべての記録物（「コンテンツ」）は、評価・内部利用・記録保管・人材育成、そして練習生または専属契約が提供された場合、その契約の履行に利用されます。',
    tit4:'[コンテンツの知的財産権]',
    tip17:'コンテンツに関連するすべての著作権（派生著作物に関する権利を含む）、肖像権、その他一切の知的財産権は、BLIX ENTERTAINMENT が全世界的に独占して保有します。応募者は、書面による別途の合意がない限り、コンテンツに関して所有権、ロイヤリティ、補償などを主張する一切の権利を放棄します。',
    pleaseSelect:'入力してください',
    pleaseCheck:'プロトコルをチェックしてください',
    submissionSuccessful :'コミット成功',
    male:'Male',
    female:'Female',
    submissionFailed:'コミットに失敗しました',
    pleaseEmailAddress:'メールアドレスを入力してください',
    sentSuccessfully:'送信成功',
    attachFile:'ファイル添付',
    imageFileSuch:'.jpg.png/MAX 50MB などの画像ファイル',
    fileSize:'ファイルサイズは50MB未満でなければなりません！',
    fileSize1:'ファイルサイズは100MB未満でなければなりません！',
    uploadFailed:'アップロード失敗',
    attach:'添付',
    emailVerification:'メール確認が送信できなかった',
    privacyPolicy:'プライバシーポリシー',
    tip21:'BLIX Entertainment（以下「当社」）は、お客様の個人情報を尊重し、保護に努めています。本ポリシーは、当社がウェブサイトやサービスを提供する際に、どのように個人情報を収集・利用・保存・保護するかを説明するものです。',
    tip22:'1. 収集する情報',
    tip23:'•	お問い合わせフォームに入力された氏名、メールアドレス、電話番号など',
    tip24:'•	IPアドレス、ブラウザの種類、アクセス記録などの技術情報',
    tip25:'2. 利用目的',
    tip26:'•	お問い合わせへの回答およびサポートの提供',
    tip27:'•	ウェブサイトやサービスの改善',
    tip28:'•	法律上の義務を遵守するため',
    tip29:'3. 情報の共有',
    tip30:'•	当社は個人情報を販売・貸与しません。',
    tip31:'•	サービス運営のために信頼できる外部業者と共有する場合があります。',
    tip32:'•	法律に基づき必要な場合、情報を開示することがあります。',
    tip33:'4. 保管期間',
    tip34:'•	収集目的が達成されるまで保管し、その後は速やかに削除します。',
    tip35:'5. 情報の保護',
    tip36:'•	合理的な安全対策を講じますが、完全な安全性を保証することはできません。',
    emailUnverified:'メールボックスが検証されていません',
    tip37:'BLIX HEADQUARTERS IS IN A MULTI-LEVELCREATIVE COMPLEX,WHERE EACH FLOORIS DEDICATED TO A SPECIALIZED FUNCTION-TRAINING, MUSICPRODUCTION, VISUAL DEVELOPMENT AND CONCEPT CREATION.',
    tip38:'クリエイティビティと革新的テクノロジーが融合し、次のエンターテインメントを生み出します。',
    year:'年',
    award:'授賞式',
    categoryWork:'部門 / 作品',
    brandOfTheYearAwards:'ブランド・オブ・ザ・イヤー賞',
    femaleVocalist:'女性ボーカリスト',
    rdKYStarAwards:'第3回 KYスターアワード',
    millionSongLogs:'1,000万ソングログ',
    gaonChartMusicAwards:'第9回 Gaonチャート・ミュージックアワード',
    discoveryoftheYearBallad:'今年の発見賞（バラード部門）',
    melonMusicAwards:'Melonミュージックアワード',
    topArtists:'OP10アーティスト',
    songDayWasBeautiful:'今年の歌（大賞）–「その時が良かった」',
    bestBallad:'ベスト・バラード',
    goldenDiscAwards:'第34回 ゴールデンディスク賞',
    digitalBonsang:'デジタル本賞',
    seoulMusicAwards:'29回 ソウル歌謡大賞',
    bonsangMainPrize:'本賞',
    popularityAward:'人気賞',
    KWaveAwards:'K-Waveアワード',
    bestAwardRewind:'最優秀R&B（「Rewind」）',
    koreaCulturalEntertainmentAwards:'大韓民国文化芸能大賞',
    kStarAward:'K-POPスター賞',
    artistTheYear:'今年のアーティスト',
    topArtistAward:'TOP10アーティスト',
    bestFemaleSoloArtist:'最優秀女性ソロアーティス',
    tip39:"BLIXビルは、トレーニング・音楽・ビジュアル制作を一体化したクリエイティブベースです。",
    tip40:"ここでは、アイデアが自由に広がり、クリエイティビティが絶えず進化し続けます。",
  },
};